module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-7306ed51.png";